import React from 'react';
import {
  NumericFormat as ReactNumberFormat,
  NumericFormatProps as ReactNumericFormatProps,
} from 'react-number-format';
import {
  TextField as MUITextField,
  TextFieldProps as MUITextFieldProps,
} from '@mui/material';

import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';

type CustomProps = {
  /**
   * style to be applied to the input container
   */
  style?: React.CSSProperties;
  /**
   * if input should be full width of container
   * defaults to true
   */
  fullWidth?: boolean;
  /**
   * autocomplete rule passed down to the input
   * defaults to "off"
   */
  autoComplete?: string;
  /**
   * Custom props passed to the input field
   */
  slotProps?: {
    input?: Record<string, any>;
    inputLabel?: Record<string, any>;
  };
};

type NumericFormatProps = CustomProps &
  MUITextFieldProps &
  ReactNumericFormatProps;

const inputStyle = {
  fontSize: fonts.md,
  '&.MuiInput-root': {
    marginTop: '0',
  },
  '&:before': {
    borderBottom: `1px solid ${colors.neutral.silver}`,
  },
};

const inputLabelStyle = {
  '&.MuiInputLabel-standard': {
    position: 'unset',
    color: colors.neutral.gray,
  },
  '&.Mui-focused': {
    color: `${colors.neutral.gray} !important`,
  },
  '&.Mui-error': {
    color: `${colors.utility.muiError} !important`,
  },
  '&.MuiInputLabel-shrink': {
    transform: 'unset',
    fontSize: fonts.sm,
  },
};

const defaultContainerStyle: React.CSSProperties = {
  width: '100%',
};

export const NumericFormat = (props: NumericFormatProps) => {
  const {
    style,
    fullWidth = true,
    autoComplete = 'off',
    variant = 'standard',
    slotProps: callerSlotProps = {},
    ...data
  } = props;

  return (
    <div style={{ ...defaultContainerStyle, ...style }}>
      <ReactNumberFormat
        // @ts-ignore
        customInput={MUITextField}
        {...data}
        variant={variant}
        fullWidth={fullWidth}
        autoComplete={autoComplete}
        slotProps={{
          ...callerSlotProps,
          input: {
            ...callerSlotProps.input,
            sx: {
              ...inputStyle,
              ...callerSlotProps.input?.sx,
            },
          },
          inputLabel: {
            shrink: true,
            ...callerSlotProps.inputLabel,
            sx: {
              ...inputLabelStyle,
              ...callerSlotProps.inputLabel?.sx,
            },
          },
        }}
      />
    </div>
  );
};

export default NumericFormat;
